<!-- Copyright (c) 2022-2024, NVIDIA CORPORATION & AFFILIATES. All rights reserved. -->

<template>
    <div id="start-instructions">
        <cumulus-tabs :allowClose="false">
            <cumulus-tab :title="'Cumulus Linux'" v-on:tabClicked="changeTab('cumulus')" />
            <cumulus-tab :title="'Onyx'" v-on:tabClicked="changeTab('onyx')" />
        </cumulus-tabs>
        <div class="instruction-body my-20">
            <div v-show="currentTab === 'cumulus'" class="m-20">
                The migration tool supports Cumulus Linux 3.7.0 and higher.
                Collect a <strong>cl-support</strong> file from your switch:
                <pre class="p-10">cumulus@switch:~$ sudo cl-support</pre>
            </div>
            <div v-show="currentTab === 'onyx'" class="m-20">
                Collect the output of <strong>show running-config</strong>
                from your switch and save it as a text file:
                <pre class="p-10">switch [standalone: master] (config) # show running-config</pre>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'StartInstructions',
    data() {
        return {
            currentTab: 'cumulus',
        };
    },
    methods: {
        changeTab(tab) {
            this.currentTab = tab;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@cumulus/air-ui-kit/variables.scss';

#start-instructions {
    text-align: left;
}
.instruction-body {
    border: 2px solid $border-gray;
}
::v-deep .c-tabs .c-tab::after {
    transition: none;
}
</style>
